export default {
  AvailableStartTimeMin: 'AvailableStartTimeMin',
  AvailableStartTimeMax: 'AvailableStartTimeMax',
  AvailableExpireTimeMin: 'AvailableExpireTimeMin',
  AvailableExpireTimeMax: 'AvailableExpireTimeMax',
  Car: 'Car',
  Cost: 'Cost',
  CarPrice: 'CarPrice',
  Commission: 'Commission',
  CommissionPercent: 'Commission Percent',
  CommissionAmount: 'Commission Amount',
  CompanyDiscountPercent: 'Courier Discount Percent',
  CompanyDiscountAmount: 'Courier Discount Amount',
  Description: 'Description',
  DateTo: 'Date To',
  DateFrom: 'Date From',
  ExtraHourCommissionPercent: 'Extra Hour Commission Percent',
  ExtraKilometerCommissionPercent: 'Extra Kilometer Commission Percent',
  laborerExtraFloorComission: 'Laborer extra floor comission',
  ExtraTariff: 'Extra Tariff',
  Employee: 'Employee',
  LaborerPrice: 'LaborerPrice',
  FreeAmount: 'FreeAmount',
  Items: 'Items',
  freeCount: 'Free count',
  packSize: 'Pack size',
  PledgePercent: 'Pledge Percent',
  pledge: 'Pledge',
  PledgeAmount: 'Pledge Amount',
  Price: 'Price',
  MarketplaceDiscountPercent: 'Marketplace Discount Percent',
  MarketplaceDiscountAmount: 'Marketplace Discount Amount',
  LaborerCommissionPercent: 'Laborer Commission Percent',
  LaborerExtraHourCommissionPercent: 'Laborer ExtraHour Commission Percent',
  LaborerCompanyDiscountPercent: 'Laborer Courier Discount Percent',
  LaborerMarketplaceDiscountPercent: 'Laborer Marketplace Discount Percent',
  ServiceHour: 'Service Hour',
  ServiceKilometer: 'Service Kilometer',
  NonRoundedAmount: 'Non Rounded Amount',
  TaxAmount: 'Tax Amount',
  TollAmount: 'Toll Amount',
  TotalAmount: 'Total Amount',
  PayableAmount: 'Payable Amount',
  AssignRequired: 'Assign Required',
  TariffAuction: 'Auction',
  Pricing: 'Pricing',
  RoundTripPercent: 'Round trip percent',
  PerKilometerPrice: 'Per kilometer price',
  TariffShowAndRecord: 'Tariff show and record',
  TrafficPlanShowAndRecord: 'Traffic plan tariff show and record',
  ExcessCommissionPercent: 'Excess commission percent',
  tariffPage: 'Tariff page',
  tariffDeletedSuccessfully: 'Tariff deleted successfully',
  ExtraKilometerCommission: 'Extra kilometer commission',
  carDistanceCost: 'Car distance cost',
  laborerExtraFloorCost: 'Laborer extra floor cost',
  primaryPrice: 'Primary price',
  perKilometerPrice: 'Per kilometer price',
  auctionCommission: 'Auction commission',
  expired: 'Expired',
  available: 'Available',
  excessCommission: 'Excess commission',
  tariffDetail: 'Tariff detail',
  waitMinutePrice: 'Cost per stop minute',
  driverIncome: 'Driver income',
  courierIncome: 'Courier Income',
  carDistanceFreeCount: 'Car distance free count',
  distanceKilometer: 'Distance kilometer price',
  waitMinute: 'Wait minute price',
  laborer: 'Laborer price',
  car: 'Car price',
  primary: 'Primary price',
  specialHour: 'Special time',
  surchargePrice: 'Surcharge price',
  weathers: 'Weather',
  noSpecialTime: 'No Time period added',
  noWeather: 'No weather added',
  conflictInSpecialTime: 'Time periods have conflict',
  addon: 'Addon Price'
}
